import React, { useState, useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import Button from '@atlaskit/button/standard-button';
import DropdownMenu, { DropdownItem } from '@atlaskit/dropdown-menu';
import { OnOpenChangeArgs } from '@atlaskit/dropdown-menu/types';
import MoreIcon from '@atlaskit/icon/glyph/more';

import { onToggleBulkDeleteSelectionMode } from 'src/redux/branches';
import RepositoryAccessGuard from 'src/sections/repository/components/repository-access-guard';
import compareMessages from 'src/sections/repository/sections/source/components/header.i18n';
import repoUrls from 'src/sections/repository/urls';
import { publishUiEvent } from 'src/utils/analytics/publish';

import branchMessages from './branch-list-actions.i18n';
import * as styles from './branch-list-actions.styled';

export const BranchListActions = ({
  repositoryFullSlug,
}: {
  repositoryFullSlug: string;
}) => {
  const [owner, slug] = repositoryFullSlug.split('/');
  const [isOpen, setDropDownState] = useState(false);
  const dispatch = useDispatch();

  const handleDropdownState = useCallback((args: OnOpenChangeArgs) => {
    setDropDownState(args.isOpen);
  }, []);

  const handleDeleteMultiple = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'dropdownItem',
      actionSubjectId: 'deleteMultipleBranches',
      source: 'branchesScreen',
    });
    dispatch(onToggleBulkDeleteSelectionMode(true));
  };

  return (
    <RepositoryAccessGuard requiredLevel="write">
      <styles.BranchListActionsWrapper>
        <DropdownMenu
          placement="bottom-end"
          onOpenChange={handleDropdownState}
          isOpen={isOpen}
          trigger={({ triggerRef, ...props }) => (
            <Button
              {...props}
              iconBefore={<MoreIcon size="medium" label="More" />}
              isSelected={isOpen}
              ref={triggerRef}
            />
          )}
        >
          <DropdownItem onClick={handleDeleteMultiple}>
            <FormattedMessage {...branchMessages.deleteMultiple} />
          </DropdownItem>
          <DropdownItem
            href={repoUrls.ui.compare(owner, slug)}
            onClick={() => {
              publishUiEvent({
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: 'compareBranchesDropdownItem',
                source: 'branchesScreen',
              });
            }}
          >
            <FormattedMessage {...compareMessages.compareRepoAction} />
          </DropdownItem>
        </DropdownMenu>
      </styles.BranchListActionsWrapper>
    </RepositoryAccessGuard>
  );
};
